import { useState } from 'react'
import { getNotificationById } from '../services/notifications'

export const useGetNotificationsById = () => {
  const [notification, setNotification] = useState()
  const [loading, setLoading] = useState(false)

  const handleGetNotificationById = async (notificationId) => {
    try {
      setLoading(true)
      const req = await getNotificationById(notificationId)
      setNotification(req)
      setLoading(false)
    } catch (error) {
    }
  }

  return {
    notification,
    loading,
    handleGetNotificationById
  }
}
